import React, { useContext, useEffect, useState } from 'react'
import '../window/style/window.css'
import cjt from '../../assets/icon/dright.png'
import returnTop from '../../assets/icon/returnTop.png'
import { Alert, Menu, Pagination, Spin } from 'antd'
import classNames from 'classnames'
import WeekHot from '../../assembly/weekHot/weekHot'
import AllRank from '../../assembly/allRanking/allRank'
import { useLocation, useNavigate } from 'react-router-dom'
import api from '../../uitil/api'
import { encode } from 'js-base64'
import { CountContext } from '../../App'

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  }
}
//选项卡导航数据
const items = [
  getItem('全部软件', '1301', null),
  getItem('单机游戏', '1302', null, [
    getItem('第三人称射击', '130201'),
    getItem('动作', '130202'),
    getItem('即时战略', '130203'),
    getItem('角色扮演', '130204'),
    getItem('竞速', '130205'),
    getItem('冒险', '130206'),
    getItem('模拟经营', '130207'),
    getItem('体育', '130208'),
    getItem('休闲', '130209'),
    getItem('射击', '130210'),
  ]),
  getItem('电脑版手游', '1303', null, [
    getItem('单机手游', '130301'),
    getItem('网络手游', '130302'),
    getItem('动作冒险', '130303'),
    getItem('角色扮演', '130304'),
    getItem('经营策略', '130305'),
    getItem('竞技对战', '130306'),
    getItem('射击游戏', '130307'),
    getItem('休闲娱乐', '130308'),
    getItem('音乐竞技', '130309'),
  ]),
  getItem('模拟器', '1304', null, [getItem('模拟器游戏', '130401')]),
  getItem('其他游戏', '1305', null, [
    getItem('棋牌游戏', '130501'),
    getItem('射击游戏', '130502'),
    getItem('网络游戏', '130503'),
    getItem('小游戏', '130504'),
    getItem('其他游戏', '130505'),
  ]),
  getItem('游戏工具', '1306', null, [
    getItem('游戏助手', '130601'),
    getItem('游戏修改器', '130602'),
  ]),
  getItem('游戏修改器', '1307', null),
]
const rootSubmenuKeys = ['1301', '1302', '1303', '1304', '1305', '1306']
export default function Game() {
  //获取路由参数
  const { pathname } = useLocation()
  //选项卡导航
  const [openKeys, setOpenKeys] = useState([])
  //初始化调用一次
  useEffect(() => {
    window.scrollTo(0, 0)
    winWeeks('13')
    const a = pathname.slice(6, 10)
    const b = pathname.slice(11, 17)
    if (a && b) {
      setOpenKeys([b, a])
      security(a, b)
    } else {
      setOpenKeys(['1301'])
      security()
    }
  }, [pathname])
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1)
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : [])
    }
  }
  //选项卡
  const [table, setTable] = useState(1)
  //内容数据
  const [recommends, setRecommends] = useState([])
  //获取context上下文总排行榜
  const value = useContext(CountContext)
  //本周热门
  const [winWeek, setWinWeek] = useState([])
  const winWeeks = async (weeksApi) => {
    await api.get(`hot/sumType/${weeksApi}`).then((data) => {
      setWinWeek(data)
    })
  }
  //请求接口
  const security = async (softType = '1301', subSoftType = '130101') => {
    await api
      .get(`query/sumType/13/softType/${softType}/subSoftType/${subSoftType}`)
      .then((data) => {
        setRecommends(data)
      })
  }

  //分页
  //页数
  const [current, setCurrent] = useState(1)
  // 用于存储每页的数据
  const [recommend, setRecommend] = useState([])
  //每页目数
  const [pageSize, setPageSize] = useState(20)

  const onChange = (page) => {
    setCurrent(page)
    window.scrollTo(0, 0)
  }

  // 根据当前页码和每页条目数获取当前页的数据
  const getCurrentPageData = (items) => {
    const startIndex = (current - 1) * pageSize // 假设每页条目数为 20，可以根据需要修改
    const endIndex = startIndex + pageSize
    const page = items.slice(startIndex, endIndex)
    return setRecommend(page)
  }
  useEffect(() => {
    getCurrentPageData(recommends)
  }, [current, recommends, pageSize, table])

  const history = useNavigate()
  //返回顶部
  const [scrollPosition, setScrollPosition] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }
    window.addEventListener('scroll', handleScroll)

    const myElement = document.getElementsByClassName('retuntop')[0]
    if (scrollPosition > 0) {
      myElement.style.display = 'block'
      myElement.classList.remove('move-down')
      myElement.classList.add('move-up')
    } else {
      myElement.classList.remove('move-up')
      myElement.classList.add('move-down')
    }
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])

  return (
    <>
      <div className="win_all">
        <div className="win_left">
          <p>分类</p>
          <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectedKeys={openKeys}
            defaultSelectedKeys={openKeys}
            style={{
              width: 150,
              backgroundColor: 'white',
            }}
            items={items}
            onClick={(e) => {
              history('/')
              setCurrent(1)
              setTable(1)
              setRecommends([])
              if (e.key === '1301') {
                setOpenKeys(['1301'])
                history(`game`)
                security(e.keyPath[0])
              } else {
                history(`game/${e.keyPath[1]}/${e.keyPath[0]}`)
                security(e.keyPath[1], e.keyPath[0])
              }
            }}
          />
        </div>
        <div className="win_center">
          <div className="center_top">
            <span>全部游戏</span>
            <ul>
              <li
                className={classNames({ active: table === 1 })}
                onClick={() => {
                  setTable(1)
                  setCurrent(1)
                  const commendId = recommends.sort((a, b) => {
                    return a.id - b.id
                  })
                  setRecommends(commendId)
                }}>
                推荐
              </li>
              <li
                className={classNames({ active: table === 2 })}
                onClick={() => {
                  setTable(2)
                  setCurrent(1)
                  const sortNews = recommends.sort((a, b) => {
                    return (
                      Date.parse(b.publish_date) - Date.parse(a.publish_date)
                    )
                  })
                  setRecommend(sortNews)
                }}>
                最新
              </li>
              <li
                className={classNames({ active: table === 3 })}
                onClick={() => {
                  setTable(3)
                  setCurrent(1)
                  const sortDownload = recommends.sort((a, b) => {
                    return b.download_count - a.download_count
                  })
                  setRecommend(sortDownload)
                }}>
                下载
              </li>
              <li
                className={classNames({ active: table === 4 })}
                onClick={() => {
                  setTable(4)
                  setCurrent(1)
                  const sortComment = recommends.sort((a, b) => {
                    return b.remark_count - a.remark_count
                  })
                  setRecommend(sortComment)
                }}>
                评论
              </li>
            </ul>
          </div>
          <div className="center_bottom">
            {recommends.length ? (
              <ul>
                {table === 1 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 2 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 3 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
                {table === 4 &&
                  recommend.map((item) => (
                    <li
                      className="item_li"
                      key={item.id}
                      onClick={() => {
                        window.open(
                          `/#${pathname}/${item.id}?item=${encode(
                            JSON.stringify(item)
                          )}`,
                          '_blank'
                        )
                      }}>
                      <div className="item_left">
                        <img src={item.icon_url} alt="" />
                      </div>
                      <div className="item_center">
                        <span className="name">{item.soft_name}</span>
                        <span className="info">{item.short_desc}</span>
                      </div>
                      <div className="item_right">
                        {item.download_count > 10000 ? (
                          <span>
                            下载:{Math.floor(item.download_count / 10000)}万
                          </span>
                        ) : (
                          <span>下载:{item.download_count}</span>
                        )}
                        <span>评论:{item.remark_count}</span>
                        <span>更新日期:{item.publish_date}</span>
                      </div>
                      <img src={cjt} className="jianto" alt="" />
                    </li>
                  ))}
              </ul>
            ) : (
              <Spin tip="Loading...">
                <Alert style={{ height: '50px' }} />
              </Spin>
            )}
          </div>
          <div className="fenye">
            <Pagination
              current={current}
              onChange={onChange}
              onShowSizeChange={(current, pageSize) => {
                setCurrent(current)
                setPageSize(pageSize)
              }}
              total={recommends.length}
              hideOnSinglePage={true}
              pageSize={pageSize}
            />
          </div>
        </div>
        <div className="win_right">
          <WeekHot hot={winWeek} />
          <AllRank hot={value.gameHot} />
        </div>
      </div>
      <div
        className="retuntop"
        onClick={() => {
          window.scrollTo(0, 0)
        }}>
        <img src={returnTop} alt="" />
      </div>
    </>
  )
}
